import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IBrandsImagesState = { };

const designTypeReducer = (
  state: types.IBrandsImagesState = defaultState, 
  action: IAction 
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_FETCH_BRAND_IMAGES: {
      return {...state, brandImages: (action as types.ISetBrandImages).brandImages};
    }
    case actionTypes.SET_FETCH_BRAND_IMAGES_SEARCH: {
      return {...state, brandImagesSearch: (action as types.ISetBrandImages).brandImages};
    }
    case actionTypes.SET_FETCH_BRAND_IMAGES_SECTION: {
      return {...state, brandImagesSection: (action as types.ISetBrandImages).brandImages};
    }
    case actionTypes.SET_BRAND_IMAGES_FILTERS: {
      if ((action as types.ISetBrandImagesFilters).typestate==="logo") 
        return {...state, filtersLogos: (action as types.ISetBrandImagesFilters).filters};
      else if ((action as types.ISetBrandImagesFilters).typestate==="stock")
        return {...state, filtersStocks: (action as types.ISetBrandImagesFilters).filters};
      else return {...state, filtersBackgrounds: (action as types.ISetBrandImagesFilters).filters};
    }
    case actionTypes.SET_COUNTER_BRAND_IMAGES: {
      if ((action as types.ISetCounterAction).typestate==="search") 
        return {...state, counterBrandImagesSearch: (action as types.ISetCounterAction).counterBrandImages};
      else
        return {...state, counterBrandImages: (action as types.ISetCounterAction).counterBrandImages};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
